<template>
  <div>
    <!-- <b-button v-if="show_button" :disabled="press" block href="#" variant="primary" @click="$emit('save')">Save</b-button> -->
      <b-card>
        <div class="d-flex flex-wrap align-items-center">
          <div class="title_sub">
            {{type.toUpperCase()}}
            <h6>
              {{comment}}
            </h6>
          </div>
        </div>
        <!-- <h4>{{type.toUpperCase()}}</h4> -->

        <hr>
        <b-input-group>
          <b-form-input :disabled="lock" :id="`ph_ip_list_${type}`" v-model="ip" placeholder="ex) 182.28.33.222, support only ip address not support network" @keyup.native.enter="add(ip)"></b-form-input>
          <b-input-group-append>
            <b-button class="btn-addition" :disabled="lock" @click="add(ip)">Add</b-button>
          </b-input-group-append>
          <b-input-group-append>
            <b-button class="btn-danger" :disabled="lock || ip_list.length == 0" @click="clear">Clear</b-button>
          </b-input-group-append>
        </b-input-group>
        <b-form-group>
          <b-list-group>
            <b-list-group-item v-for="(item, index) in ip_list" :key="index" @click="remove(index)" style="cursor:pointer">
              <i v-if="!lock" class="pull-right fa fa-times mr-3"></i> {{item}}
            </b-list-group-item>
          </b-list-group>
        </b-form-group>
      </b-card>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>